const RECOVERY_STORAGE_KEY = 'dcentriq.chunkLoadRecovery.reloadedAt';
const RECOVERY_QUERY_PARAM = 'chunkReload';
const RECOVERY_WINDOW_MS = 5 * 60 * 1000;
const CHUNK_FILE_PATTERN = /\/static\/js\/[^/]+\.chunk\.js(?:\?|$)/;
const CHUNK_ERROR_PATTERN =
  /Loading chunk \d+ failed|Loading CSS chunk \d+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i;

const getStringValue = (value) => (value === undefined || value === null ? '' : `${value}`);

const isChunkFile = (fileName) => CHUNK_FILE_PATTERN.test(getStringValue(fileName));

const isChunkLoadError = (error) => {
  const name = getStringValue(error?.name);
  const message = getStringValue(error?.message || error);
  const fileName = getStringValue(error?.filename || error?.fileName);

  return name === 'ChunkLoadError' || CHUNK_ERROR_PATTERN.test(message) || isChunkFile(fileName);
};

const getLastReloadAt = () => {
  try {
    return Number(window.sessionStorage.getItem(RECOVERY_STORAGE_KEY));
  } catch {
    return 0;
  }
};

const setLastReloadAt = (value) => {
  try {
    window.sessionStorage.setItem(RECOVERY_STORAGE_KEY, `${value}`);
  } catch {
    // If sessionStorage is unavailable, still attempt the reload below.
  }
};

const reloadWithCacheBust = () => {
  const now = Date.now();
  const lastReloadAt = getLastReloadAt();

  if (lastReloadAt && now - lastReloadAt < RECOVERY_WINDOW_MS) return;

  setLastReloadAt(now);

  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set(RECOVERY_QUERY_PARAM, `${now}`);
  window.location.replace(nextUrl.toString());
};

export const installChunkLoadRecovery = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('error', (event) => {
    if (isChunkLoadError(event.error) || isChunkFile(event.filename)) {
      reloadWithCacheBust();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadWithCacheBust();
    }
  });
};
